import React from 'react';
import {
  Banner,
  BannerButton,
  BannerContainer,
  Bold,
  ButtonBack,
  ButtonBackText,
  ButtonConfirm,
  ButtonConfirmText,
  ButtonContainer,
  Container,
  ContainerStationHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  Paragraph,
  Title,
} from './styles';

import bannerBrb from '../../../assets/images/banners/brb_baratao.webp';
import {useTheme} from 'styled-components/native';


import {SafeAreaView} from 'react-native-safe-area-context';
import {useNavigation} from '@react-navigation/native';

interface Props {
  showModal: boolean;
  onDismiss: () => void;
}

export function BRBModal({showModal, onDismiss}: Props) {
  const theme = useTheme();
  const navigation = useNavigation();

  function handleConfirm() {
    navigation.navigate('AddCreditCard', {voucher: false});
    onDismiss();
  }

  return (
    <Container
      isVisible={showModal}
      onBackButtonPress={onDismiss}
      onBackdropPress={onDismiss}>
      <ModalContent>
        <ContainerStationHeader>
          <BannerContainer>
            <BannerButton activeOpacity={1}>
              <Banner source={bannerBrb} />
            </BannerButton>
          </BannerContainer>
        </ContainerStationHeader>
        <ModalBody>
          <Title>
            Pague com um cartão de crédito BRB e ganhe mais DESCONTO!
          </Title>

          <Paragraph>
            Ao cadastrar um cartão BRB e realizar sua primeira compra no app
            Baratão, você recebe automaticamente <Bold>R$ 0,20</Bold> de
            desconto por litro na primeira utilização e até <Bold>R$ 0,15</Bold>{' '}
            por litro nas demais compras. O desconto é aplicado direto no valor
            final, basta pagar com o Cartão BRB.
          </Paragraph>
        </ModalBody>
        <ModalFooter>
          <SafeAreaView>
            <ButtonContainer>
              <ButtonBack onPress={onDismiss} activeOpacity={0.7}>
                <ButtonBackText>Fechar</ButtonBackText>
              </ButtonBack>
              <ButtonConfirm
                onPress={() => handleConfirm()}
                activeOpacity={0.7}>
                <ButtonConfirmText>Adicionar cartão</ButtonConfirmText>
              </ButtonConfirm>
            </ButtonContainer>
          </SafeAreaView>
        </ModalFooter>
      </ModalContent>
    </Container>
  );
}
